import type { FaireProductEntity } from "../../entity_types/product";

export const p_heq6767nrz: FaireProductEntity = {
  token: "p_heq6767nrz",
  type: "product",
  name: "Animal Friends Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a5b3dc2e4812f7a92c72bb801f6d4ecdaf6a59d1098f82c021928256982be4ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/44426a4a54f6ec3fbfb3a4bb8d4ea4065647086bb5b6ea6c11916b824d908d96.jpeg",
    "https://cdn.faire.com/fastly/845e5369b6c9571586cb7caf3d501b5f454e44705c820ea05bfc048150875c37.jpeg",
    "https://cdn.faire.com/fastly/fcd61db4f50ff37a0638c9c93a5386bffad5d9d16914b8d40994e27e9570d564.jpeg",
    "https://cdn.faire.com/fastly/27fc7237698e9377f181757441a8a76edd26c06d08016b2bb12f8fbfaa8323df.webp",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:38.972Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
